import { useEffect, useState } from "react";
import { Download } from "lucide-react";
import api from "@/api";
import { formatINR } from "@/store/StoreContext";
import { toast } from "sonner";

const TAGS = ["VIP", "Repeat Customer", "High Value", "COD Risk", "Wholesale", "Influencer"];

export default function AdminCustomers() {
  const [items, setItems] = useState(null);
  const load = () => api.get("/admin/customers").then(({ data }) => setItems(data));
  useEffect(() => { load(); }, []);
  const toggleTag = async (c, tag) => {
    const tags = (c.tags || []).includes(tag) ? (c.tags || []).filter((t) => t !== tag) : [...(c.tags || []), tag];
    if (String(c.id).startsWith("guest-")) { toast.info("Tags can only be set on registered customers"); return; }
    await api.put(`/admin/customers/${c.id}/tags`, { tags });
    load();
  };
  const exportCsv = () => api.get("/admin/export/customers", { responseType: "blob" }).then((r) => {
    const u = URL.createObjectURL(r.data); const a = document.createElement("a"); a.href = u; a.download = "customers.csv"; a.click();
  });
  return (
    <div data-testid="admin-customers">
      <div className="flex flex-wrap items-center justify-between gap-3 mb-6">
        <h1 className="font-serif text-3xl">Customers</h1>
        <button onClick={exportCsv} data-testid="customers-export-btn" className="tq-btn-outline !py-2.5"><Download size={14} /> Export CSV</button>
      </div>
      {!items ? <div className="h-64 bg-white animate-pulse" /> : items.length === 0 ? (
        <div className="bg-white border border-[#E5DEC9] p-12 text-center text-[#6E6D6A]">No customers yet.</div>
      ) : (
        <div className="bg-white border border-[#E5DEC9] overflow-x-auto">
          <table className="w-full text-sm min-w-[820px]">
            <thead><tr className="text-left text-[10px] uppercase tracking-[0.15em] text-[#8C7A5E] border-b border-[#E5DEC9]">
              <th className="p-3">Customer</th><th className="p-3">Orders</th><th className="p-3">Lifetime Spend</th><th className="p-3">AOV</th><th className="p-3">Last Order</th><th className="p-3">Tags</th>
            </tr></thead>
            <tbody>
              {items.map((c) => (
                <tr key={c.id} className="border-b border-[#F4EFE6]" data-testid={`customer-row-${c.email}`}>
                  <td className="p-3"><p className="font-medium">{c.name} {c.role === "guest" && <span className="text-[9px] uppercase text-[#9a938a]">(guest)</span>}</p><p className="text-xs text-[#9a938a]">{c.email}{c.phone ? ` · ${c.phone}` : ""}</p></td>
                  <td className="p-3 font-semibold">{c.order_count}</td>
                  <td className="p-3 font-semibold">{formatINR(c.lifetime_spend)}</td>
                  <td className="p-3">{formatINR(c.aov)}</td>
                  <td className="p-3 text-xs text-[#6E6D6A]">{c.last_order ? new Date(c.last_order).toLocaleDateString("en-IN", { day: "numeric", month: "short", year: "numeric" }) : "—"}</td>
                  <td className="p-3">
                    <div className="flex flex-wrap gap-1">
                      {TAGS.map((t) => (
                        <button key={t} onClick={() => toggleTag(c, t)} data-testid={`customer-tag-${t.replace(/\s+/g, "-")}`}
                          className={`text-[9px] font-bold uppercase px-1.5 py-0.5 border ${(c.tags || []).includes(t) ? "bg-[#D4AF37] border-[#D4AF37] text-[#121212]" : "border-[#E5DEC9] text-[#9a938a]"}`}>{t}</button>
                      ))}
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
